<template>

  <v-container fluid>

    <!-- 업로드 프로그레스 -->
    <comloading :isVisible="progress_dialog" :progress="progress_value" />

    <v-row align="center" dense no-gutters>
      <v-col cols="12" md="3">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <v-col cols="12" md="3">
      </v-col>
      <v-col cols="12" md="3">
      </v-col>      
      <v-col cols="12" md="1">
        <v-btn :data-my-variable="$i18n.locale === 'ko' ? 'true' : 'false'" class="yellow_btn ml-1" elevation="0" outlined large @click="save">{{$t('common_save2')}}</v-btn>
      </v-col>
    </v-row>


    <v-row>

      <v-col cols="12">
        <editor
          :initialValue="editorText"
          :options="editorOptions"
          height="750px"
          initialEditType="wysiwyg"
          previewStyle="vertical"
          ref="toastuiEditor"
          />
      </v-col>

    </v-row>
      

  </v-container>
</template>

<script>
import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/vue-editor';
import 'tui-color-picker/dist/tui-color-picker.css';
import colorSyntax from '@toast-ui/editor-plugin-color-syntax';
export default {

    components:{
      'editor':Editor,
    },

    methods: {




      async save(){

        /*
        if(this.editedItem.PAGE_INFO.length == 0){
          this.$alert(this.$t('eventformat_msg1'));
          return;
        }
        */

        this.editedItem.POLICY = this.$refs.toastuiEditor.invoke('getHtml');

        this.$http.post(this.$host+'/api/BasicPolicyUpdate',
          {
              POLICY: this.editedItem.POLICY
            , POLICYENG: this.editedItem.POLICYENG
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          
          this.progress_dialog = false;
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
              this.$alert(this.$t('eventinfo_msg17')).then(()=>{
                this.loadpage();
              });


          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }else{
            this.$alert(this.$t('eventinfo_msg18'));
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
            
            this.progress_dialog = false;
            this.$alert(this.$t('eventinfo_msg18'));
        });
        
      },


      loadpage(){

        this.items.splice(0, this.items.length);   //데이터 초기화


          
          this.$http.post(this.$host+'/api/getBasicPolicy',
            {
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.editedItem.POLICY    = result.data.resultData[0].POLICY;
              this.editedItem.POLICYENG = result.data.resultData[0].POLICYENG;
              this.editorText = this.editedItem.POLICY;
              
              this.$refs.toastuiEditor.invoke('setHtml', this.editedItem.POLICY); //팝업이 떠서 에디터가 생성된 후 읽을 수 있다.            

            }else if(result.data.resultCode == 2){
              //로그인 필요
              
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){


        //첫페이지 로드
        this.loadpage();


        

      },

      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");

      },



    },

    beforeMount(){

    },

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인 해야해
        this.$router.push("Login");
      }
    },

    computed: {
    },

    watch: {
    },

    beforeDestroy(){
      if(this.editor != null){
        this.editor.destroy()
      }
    },      

    data () {
      return {

        editor:null,
        editorText: "This is init",
        editorOptions : {
                          minHeight: '200px',
                          language: 'en-US',
                          useCommandShortcut: true,
                          useDefaultHTMLSanitizer: true,
                          usageStatistics: false,
                          hideModeSwitch: false,
                          plugins:[colorSyntax],
                          toolbarItems: [
                            'heading',
                            'bold',
                            'italic',
                            'strike',
                            'divider',
                            //'hr',
                            'quote',
                            'divider',
                            'ul',
                            'ol',
                            'task',
                            //'indent',
                            //'outdent',
                            'divider',
                            //'table',
                            //'image',
                            //'link',
                            //'divider',
                            //'code',
                            //'codeblock'
                          ]
                        },        

        editedIndex: -1,
        dialog : false,

        items: [],
        
        defaultItem: {
          PAGE_INFO: []
        },

        editedItem: {
          POLICY:"",
          POLICYENG:""
        },

        SEARCH_COM_IDX: null,
        SEARCH_COM_NAME: '',
        SEARCH_EVENT_IDX: null,
        SEARCH_EVENT_NAME: '',
        grade : 0,
        
        progress_dialog : false,    //로딩 표시
        progress_value:0,


      }
    }
  }
</script>
<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>  
  


</style>
